import React, { useEffect } from "react";
import "./style.css";

function SplashScreen({ onFinish }) {
  useEffect(() => {
    // Increased duration to 4.5s for a more "cinematic" feel
    const timer = setTimeout(() => {
      onFinish?.();
    }, 4500);
    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className="splash-container">
      <div className="splash-bg-glow" />

      <div className="splash-content">
        <svg
          className="splash-logo-svg"
          viewBox="0 0 100 120"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* The Location Pin / Mountain Frame */}
          <path
            className="path-draw pin-outline"
            d="M50 115 C30 95 10 75 10 45 C10 20 28 5 50 5 C72 5 90 20 90 45 C90 75 70 95 50 115Z"
          />

          {/* The Sun */}
          <circle className="sun-pulse" cx="50" cy="32" r="10" fill="#FFD700" />

          {/* Mountains - Styled to match the 'W' shape in your logo */}
          <path
            className="path-draw mountain-path"
            d="M15 65 L35 40 L50 60 L65 40 L85 65"
          />

          {/* Bottom Accent / Chevron */}
          <path className="path-draw accent-path" d="M40 85 L50 75 L60 85" />
        </svg>

        <h1 className="splash-title">TAJINVEST</h1>

        <div className="loader-container">
          <div className="loader-fill" />
        </div>
      </div>
    </div>
  );
}

export default SplashScreen;
